export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AggregatedShipToParty = {
  __typename?: 'AggregatedShipToParty';
  data?: Maybe<Array<CommerceAddress>>;
  key: Scalars['String'];
  totalCount: Scalars['Int'];
};

export type AggregatedShipToPartyConnection = {
  __typename?: 'AggregatedShipToPartyConnection';
  nodes?: Maybe<Array<AggregatedShipToParty>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int'];
};

export type AggregatedShipToPartyOptions = {
  groupBy: Scalars['String'];
  pageOptions?: Maybe<PageOptions>;
  searchOptions?: Maybe<PartnerSearchOptions>;
  sortOptions?: Maybe<SortOptions>;
};

export type BillingAdmin = {
  __typename?: 'BillingAdmin';
  atlassianAccountId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  isPartnerAdmin?: Maybe<Scalars['Boolean']>;
  picture?: Maybe<Scalars['String']>;
};

export type BillingAdminConnection = {
  __typename?: 'BillingAdminConnection';
  disableRemoveFeature?: Maybe<Scalars['Boolean']>;
  edges?: Maybe<Array<Maybe<BillingAdminEdge>>>;
  totalCount: Scalars['Int'];
};

export type BillingAdminEdge = {
  __typename?: 'BillingAdminEdge';
  node: BillingAdmin;
};

export type BillingAdminOptions = {
  partnerAccountId: Scalars['String'];
  billingAdminIds: Array<Scalars['String']>;
};

export type CommerceAddress = {
  __typename?: 'CommerceAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  hasLinkedSubscriptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  priceEligibility?: Maybe<Scalars['String']>;
  /** Pricing plan type that orders should be allowed for. ([CCP Reference](https://hello.atlassian.net/wiki/spaces/tintin/pages/927987612/Elements+of+CCP+Architecture)) */
  shipToPriceEligibility?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxExempt?: Maybe<Scalars['Boolean']>;
  taxId?: Maybe<Scalars['String']>;
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  taxLabels?: Maybe<Array<Maybe<TaasTaxLabel>>>;
  isActive?: Maybe<Scalars['Boolean']>;
};

/**
 * The connection model provides a standard mechanism for slicing and paginating the result set.
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm)
 */
export type Connection = {
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Common parameters when searching for a connection and paginating (either by cursor or offset). Uses Hydra terminology by default. */
export type ConnectionSearchOptions = {
  after?: Maybe<Scalars['String']>;
  cursor?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<SortType>;
};

/** Health of the graph by basic dependency checks */
export type DependencyHealth = {
  __typename?: 'DependencyHealth';
  key: Scalars['String'];
  label: Scalars['String'];
  successful: Scalars['Boolean'];
};

/**
 * A type that is returned in list form by a connection type’s edges field is considered by this spec to be an Edge Type. Edge types must be an “Object” as defined in the “Type System” section of the GraphQL Specification.
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm#sec-Edges)
 */
export type Edge = {
  cursor?: Maybe<Scalars['ID']>;
};

/** Filter option to be sent in filterOptions array when filtering for a connection. */
export type FilterOption = {
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  /**
   * values to pass as an array in case where filter option supports key value need array
   * Union is another option to update value property to be used but that need a major refactoring of code
   */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * Information about pagination in a connection
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo)
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
};

export type PageOptions = {
  cursor?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
};

export type PartnerAccount = {
  __typename?: 'PartnerAccount';
  alternateDomains?: Maybe<Array<Scalars['String']>>;
  billTo?: Maybe<PartnerAccountBillTo>;
  domain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  partnerType?: Maybe<Scalars['String']>;
  payOnAccount?: Maybe<Scalars['Boolean']>;
  programLevelGlobal?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Maybe<Scalars['String']>>>;
  specializations?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  transactionAccountId?: Maybe<Scalars['String']>;
  verifiedExpertise?: Maybe<Array<Scalars['String']>>;
};

export type PartnerAccountBillTo = {
  __typename?: 'PartnerAccountBillTo';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type PartnerAccountConnection = {
  __typename?: 'PartnerAccountConnection';
  nodes?: Maybe<Array<PartnerAccount>>;
  totalCount: Scalars['Int'];
};

export type PartnerAccountFilterOptions = {
  domain?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type PartnerAccountOptions = {
  filterOptions?: Maybe<PartnerAccountFilterOptions>;
};

export enum PartnerSearchContext {
  ALL = 'ALL',
  COMPANY = 'COMPANY',
  CUSTOMER_ADDRESS = 'CUSTOMER_ADDRESS',
  INVOICE_ID = 'INVOICE_ID',
  PERSON = 'PERSON',
  REFUND_ID = 'REFUND_ID',
  SITE_URL = 'SITE_URL',
  SUBSCRIPTION_ID = 'SUBSCRIPTION_ID',
}

export type PartnerSearchOptions = {
  query?: Maybe<Scalars['String']>;
  searchContext?: Maybe<PartnerSearchContext>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type Query = {
  __typename?: 'Query';
  /** Provides insight to if a dependency is currently accessible */
  deepcheck: Array<Maybe<DependencyHealth>>;
  partnerAccount?: Maybe<PartnerAccount>;
  partnerAccounts?: Maybe<PartnerAccountConnection>;
  shipToPartyGrouped?: Maybe<ShipToPartyAggregatedConnection>;
  transactionAccount: TransactionAccount;
  /** Determines if the graph is currently running */
  up: Scalars['Boolean'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPartnerAccountArgs = {
  id: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryPartnerAccountsArgs = {
  options?: Maybe<PartnerAccountOptions>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryShipToPartyGroupedArgs = {
  pageParams?: Maybe<ShipToPartyPageParams>;
  searchParams?: Maybe<ShipToPartySearchParams>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTransactionAccountArgs = {
  id: Scalars['ID'];
};

export type ShipToPartyAggregated = {
  __typename?: 'ShipToPartyAggregated';
  data?: Maybe<Array<Maybe<CommerceAddress>>>;
  key?: Maybe<Scalars['String']>;
};

export type ShipToPartyAggregatedConnection = {
  __typename?: 'ShipToPartyAggregatedConnection';
  nodes?: Maybe<Array<Maybe<ShipToPartyAggregated>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ShipToPartyConnection = {
  __typename?: 'ShipToPartyConnection';
  nodes?: Maybe<Array<CommerceAddress>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ShipToPartyFilterOptions = {
  ids?: Maybe<Array<Scalars['String']>>;
  names?: Maybe<Array<Scalars['String']>>;
};

export enum ShipToPartyGroupBy {
  name = 'name',
}

export type ShipToPartyOptions = {
  filterOptions?: Maybe<ShipToPartyFilterOptions>;
  pageOptions?: Maybe<PageOptions>;
  searchOptions?: Maybe<PartnerSearchOptions>;
  sortOptions?: Maybe<SortOptions>;
};

export type ShipToPartyPageParams = {
  cursor?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  groupBy?: Maybe<ShipToPartyGroupBy>;
  offset?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

export type ShipToPartySearchParams = {
  query: Scalars['String'];
  transactionAccountId: Scalars['String'];
};

export type EntitlementToOrganizationLinkSearchParams = {
  query: Scalars['String'];
};

/** Direction to sort returned connection */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SortOptions = {
  direction?: Maybe<SortDirection>;
  key?: Maybe<Scalars['String']>;
};

/** ElasticSearch Script for finely tuned sorts (used with Hydra) */
export type SortScript = {
  order?: Maybe<Scalars['String']>;
  returnType?: Maybe<Scalars['String']>;
  script?: Maybe<Scalars['String']>;
};

/** Available sort options; defaults to Hydra terminology */
export type SortType = {
  /** Fields to sort, must be equal length to sortFieldsDirections */
  sortFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Direction to sort, must be equal length to sortFields */
  sortFieldsDirections?: Maybe<Array<Maybe<SortDirection>>>;
  sortScript?: Maybe<Array<Maybe<SortScript>>>;
};

export type TaasTaxLabel = {
  __typename?: 'TaasTaxLabel';
  region?: Maybe<Scalars['String']>;
  taxIdLabels?: Maybe<Array<Maybe<TasstaxIdLabel>>>;
};

export type TassTaxIdLabelMetadata = {
  __typename?: 'TassTaxIdLabelMetadata';
  labels?: Maybe<Array<Maybe<TassTaxIdLabelMetadataLabel>>>;
  type?: Maybe<Scalars['String']>;
};

export type TassTaxIdLabelMetadataLabel = {
  __typename?: 'TassTaxIdLabelMetadataLabel';
  default?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  vatStatus?: Maybe<Scalars['String']>;
};

export type TasstaxIdLabel = {
  __typename?: 'TasstaxIdLabel';
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  metadata?: Maybe<TassTaxIdLabelMetadata>;
  type?: Maybe<Scalars['String']>;
};

export type TaxId = {
  __typename?: 'TaxId';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  metadata?: Maybe<TaxMetadata>;
  taxExempt?: Maybe<Scalars['Boolean']>;
};

export type TaxMetadata = {
  __typename?: 'TaxMetadata';
  vatStatus?: Maybe<Scalars['String']>;
};

export type TransactionAccount = {
  __typename?: 'TransactionAccount';
  aggregatedShipToParty?: Maybe<AggregatedShipToPartyConnection>;
  billingAdmins?: Maybe<BillingAdminConnection>;
  id: Scalars['ID'];
  shipToParty?: Maybe<ShipToPartyConnection>;
};

export type TransactionAccountAggregatedShipToPartyArgs = {
  aggregatedShipToPartyOptions?: Maybe<AggregatedShipToPartyOptions>;
  isOrgSearchEnabled?: Maybe<Scalars['Boolean']>;
};

export type TransactionAccountBillingAdminsArgs = {
  billingAdminOptions?: Maybe<BillingAdminOptions>;
};

export type TransactionAccountShipToPartyArgs = {
  shipToPartyOptions?: Maybe<ShipToPartyOptions>;
};

export type FetchAggregatedShipToPartiesForTransactionAccountPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  aggregatedShipToPartyOptions?: Maybe<AggregatedShipToPartyOptions>;
  isOrgSearchEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type FetchAggregatedShipToPartiesForTransactionAccountPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      aggregatedShipToParty?: Maybe<
        { __typename?: 'AggregatedShipToPartyConnection' } & Pick<AggregatedShipToPartyConnection, 'totalCount'> & {
            pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
            nodes?: Maybe<
              Array<
                { __typename?: 'AggregatedShipToParty' } & Pick<AggregatedShipToParty, 'key' | 'totalCount'> & {
                    data?: Maybe<
                      Array<
                        { __typename?: 'CommerceAddress' } & Pick<
                          CommerceAddress,
                          | 'name'
                          | 'id'
                          | 'addressLine1'
                          | 'addressLine2'
                          | 'city'
                          | 'state'
                          | 'country'
                          | 'postcode'
                          | 'taxId'
                          | 'priceEligibility'
                          | 'taxExempt'
                        > & {
                            taxIds?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                                      metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                                    }
                                >
                              >
                            >;
                            taxLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                                      taxIdLabels?: Maybe<
                                        Array<
                                          Maybe<
                                            { __typename?: 'TasstaxIdLabel' } & Pick<
                                              TasstaxIdLabel,
                                              'description' | 'displayName' | 'type'
                                            > & {
                                                metadata?: Maybe<
                                                  { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                                    TassTaxIdLabelMetadata,
                                                    'type'
                                                  > & {
                                                      labels?: Maybe<
                                                        Array<
                                                          Maybe<
                                                            { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                              TassTaxIdLabelMetadataLabel,
                                                              'default' | 'label' | 'vatStatus'
                                                            >
                                                          >
                                                        >
                                                      >;
                                                    }
                                                >;
                                              }
                                          >
                                        >
                                      >;
                                    }
                                >
                              >
                            >;
                          }
                      >
                    >;
                  }
              >
            >;
          }
      >;
    };
};

export type FetchBillingAdminsForTransactionAccountPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  billingAdminOptions?: Maybe<BillingAdminOptions>;
}>;

export type FetchBillingAdminsForTransactionAccountPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      billingAdmins?: Maybe<
        { __typename?: 'BillingAdminConnection' } & Pick<BillingAdminConnection, 'disableRemoveFeature'> & {
            edges?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'BillingAdminEdge' } & {
                    node: { __typename?: 'BillingAdmin' } & Pick<
                      BillingAdmin,
                      'email' | 'atlassianAccountId' | 'fullName' | 'isPartnerAdmin' | 'picture'
                    >;
                  }
                >
              >
            >;
          }
      >;
    };
};

export type FetchShipToPartiesForTransactionAccountPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  shipToPartyOptions?: Maybe<ShipToPartyOptions>;
}>;

export type FetchShipToPartiesForTransactionAccountPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & Pick<TransactionAccount, 'id'> & {
      shipToParty?: Maybe<
        { __typename?: 'ShipToPartyConnection' } & {
          pageInfo?: Maybe<{ __typename?: 'PageInfo' } & Pick<PageInfo, 'endCursor' | 'hasNextPage'>>;
          nodes?: Maybe<
            Array<
              { __typename?: 'CommerceAddress' } & Pick<
                CommerceAddress,
                | 'name'
                | 'id'
                | 'addressLine1'
                | 'addressLine2'
                | 'city'
                | 'state'
                | 'country'
                | 'postcode'
                | 'taxId'
                | 'priceEligibility'
                | 'taxExempt'
                | 'isActive'
              > & {
                  taxIds?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'TaxId' } & Pick<TaxId, 'id' | 'label' | 'taxExempt'> & {
                            metadata?: Maybe<{ __typename?: 'TaxMetadata' } & Pick<TaxMetadata, 'vatStatus'>>;
                          }
                      >
                    >
                  >;
                  taxLabels?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: 'TaasTaxLabel' } & Pick<TaasTaxLabel, 'region'> & {
                            taxIdLabels?: Maybe<
                              Array<
                                Maybe<
                                  { __typename?: 'TasstaxIdLabel' } & Pick<
                                    TasstaxIdLabel,
                                    'description' | 'displayName' | 'type'
                                  > & {
                                      metadata?: Maybe<
                                        { __typename?: 'TassTaxIdLabelMetadata' } & Pick<
                                          TassTaxIdLabelMetadata,
                                          'type'
                                        > & {
                                            labels?: Maybe<
                                              Array<
                                                Maybe<
                                                  { __typename?: 'TassTaxIdLabelMetadataLabel' } & Pick<
                                                    TassTaxIdLabelMetadataLabel,
                                                    'default' | 'label' | 'vatStatus'
                                                  >
                                                >
                                              >
                                            >;
                                          }
                                      >;
                                    }
                                >
                              >
                            >;
                          }
                      >
                    >
                  >;
                }
            >
          >;
        }
      >;
    };
};

export type FetchShipToPartyForWidgetInPpcQueryVariables = Exact<{
  id: Scalars['ID'];
  shipToPartyOptions?: Maybe<ShipToPartyOptions>;
}>;

export type FetchShipToPartyForWidgetInPpcQuery = { __typename?: 'Query' } & {
  transactionAccount: { __typename?: 'TransactionAccount' } & {
    shipToParty?: Maybe<
      { __typename?: 'ShipToPartyConnection' } & {
        nodes?: Maybe<
          Array<
            { __typename?: 'CommerceAddress' } & Pick<
              CommerceAddress,
              'name' | 'id' | 'addressLine1' | 'addressLine2' | 'city' | 'state' | 'country' | 'postcode'
            >
          >
        >;
      }
    >;
  };
};
